import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import { updateCurrentTeam } from "../../redux/currentTeamSlice";
import Cookies from "universal-cookie";
import { removeSharedCookie } from "../../config/cookiesSettings";
import { Link } from "react-router-dom";
import ConditionalRender from "../../ConditionalRender";
import almaLogo from "../../almanews_logo.svg";
import Avatar from "../../design_system/components/Avatar/Avatar.jsx";
import { apiAgent } from "../../axiosConfig";
import { switchCurrentTeam } from "../../actions/teamSliceActions/actions";
import { currentPath, recordRoute } from "../../teamContext/routes";
import useWindowSize from "../custom_hooks/useWindowSize";
import { isWidthDown } from "../utils/designUtils";
import SmallLoginHeader from "./SmallLoginHeader";
import useCheckUserAccess from "../custom_hooks/useCheckUserAccess";
import { Button } from "../../design_system/components/Button/Button";
import { TabItem } from "../../design_system/components/Tabs/TabItem";
import { ClickableDropdown } from "../../design_system/components/Dropdown/Dropdown";
import { DropdownMenu } from "../../design_system/components/Dropdown/DropdownMenu";
import { DropdownItem } from "../../design_system/components/Dropdown/DropdownItem";
import { DropdownTrigger } from "../../design_system/components/Dropdown/DropdownTrigger";
import Icons from "../../design_system/components/Icons";
import { SuggestionBox } from "../../design_system/components/Input Fields/SuggestionBox.jsx";
import SettingsPopup from "../views/settings/SettingsPopup";
import DataExports from "../views/data_exports/index.js";
import { CRM_CONFIG } from "../../configurations/application_config";
import { canUseAnyExport, canUseMemberManagementAction, canViewFeedType } from "../../utils/access";

const LoggedinHeader = (props) => {
    const current_user = useSelector((state) => state.current_user.user);
    const current_team = useSelector((state) => state.current_team.team);
    const [activeTab, setActiveTab] = useState("");
    const [settingsOpen, setSettingsOpen] = useState(false);
    const [settingsInitialTab, setSettingsInitialTab] = useState("profile");
    const [dataExportsOpen, setDataExportsOpen] = useState(false);
    const _dispatch = useDispatch();
    const _history = useHistory();
    const windowsDimension = useWindowSize();
    const checkUserAccess = useCheckUserAccess();
    const canInviteMembers = canUseMemberManagementAction({
        permissionKey: "members.invite",
        user: current_user,
        team: current_team,
    });
    const canViewDataExports = canUseAnyExport({
        team: current_team,
        legacyAllowed: checkUserAccess("page_data_exports"),
    });
    const canViewMapper = current_team.displayable_features?.display_mapper_suggestions === true;
    const canViewAnyFeed = canViewFeedType({ typeKey: "all", team: current_team, user: current_user });

    const LOGIN_HEADERS = [
        { key: "NewsFeed", label: "Newsfeed", url: "/feed", icon: "dashboard", access: canViewAnyFeed },
        { key: "ProspectList", label: "Prospects", url: "/prospects", icon: "users-group", access: true },
        {
            key: "DirectoryList",
            label: "Directory",
            url: current_team.internal_crm_enabled === true ? CRM_CONFIG.DIRECTORY_URL : "/directory",
            activeUrl: "/directory",
            external: current_team.internal_crm_enabled === true,
            icon: "home",
            access: current_team.displayable_features.display_new_directory || current_user.is_publisher
        },
        {
            key: "ReportList",
            label: "Reports",
            url: current_team.internal_crm_enabled === true ? CRM_CONFIG.REPORTS_URL : "/reports",
            activeUrl: "/reports",
            external: current_team.internal_crm_enabled === true,
            icon: "graph",
            access: current_team.displayable_features.display_new_directory || current_user.is_publisher
        },
    ];

    const handleSwitchAccount = () => {
        const cookies = new Cookies();
        removeSharedCookie(cookies, "team_id");
        _dispatch(updateCurrentTeam({}));
        _history.push("/switch_acc");
    };

    useEffect(() => {
        setHeader();
        const unlisten = _history.listen(() => {
            setHeader();
        });
        return unlisten;
    }, []);

    const setHeader = () => {
        let indexofHeader = LOGIN_HEADERS.findIndex(header => (header.activeUrl || header.url) === _history.location.pathname);
        indexofHeader !== -1 ? setActiveTab(LOGIN_HEADERS[indexofHeader].key) : setActiveTab("");
    };

    const handleRedirectToProspectShow = (name, val) => {
        if (val?.id) _history.push(`/prospects/${val.id}`);
    };

    const forceSwitchTeam = (n, t) => {
        if (!t) return;
        let team = { ...t, id: t._id, approved_at: true };
        const destination = recordRoute(currentPath()) ? "/feed" : window.location.pathname;
        _dispatch(switchCurrentTeam(team, { destination }));
    };

    const openSettings = (tab = "profile") => {
        setSettingsInitialTab(tab);
        setSettingsOpen(true);
    };

    useEffect(() => {
        const handleOpenSettings = (e) => openSettings(e.detail?.tab || "profile");
        const handleOpenDataExports = () => setDataExportsOpen(true);
        window.addEventListener('open-settings', handleOpenSettings);
        window.addEventListener('open-data-exports', handleOpenDataExports);
        return () => {
            window.removeEventListener('open-settings', handleOpenSettings);
            window.removeEventListener('open-data-exports', handleOpenDataExports);
        };
    }, []);

    const renderTeamSwitcher = () => {
        return (
            <div className="header-team-switcher">
                <SuggestionBox
                    suggestionUrl="/suggestions/teams"
                    placeholder="Search Teams"
                    name="Team Switch"
                    showIcon={true}
                    IconName="search"
                    defaultValue={current_team.name}
                    onSelect={forceSwitchTeam}
                    Size="Large"
                    dropdownWidth={240}
                    customMenuStyle={{ marginTop: 8 }}
                />
            </div>
        );
    };

    const renderLoginDropDown = () => {
        return (
            <DropdownMenu customStyle={{ right: 0, left: "auto", width: 240, marginTop: 8 }}>
                <DropdownItem IconName="settings" onClick={() => openSettings("profile")}>
                    Settings
                </DropdownItem>
                <DropdownItem IconName="tag" onClick={() => _history.push("/manage/tags")}>
                    Tags/Labels
                </DropdownItem>
                <ConditionalRender if={canViewMapper}>
                    <DropdownItem IconName="mapper-suggestions" onClick={() => _history.push("/mapper-suggestions")}>
                        Mapper Suggestions
                    </DropdownItem>
                </ConditionalRender>

                <ConditionalRender if={canViewDataExports}>
                    <DropdownItem IconName="exports" onClick={() => setDataExportsOpen(true)}>
                        Data exports
                    </DropdownItem>
                </ConditionalRender>


                <ConditionalRender if={canInviteMembers}>
                    <DropdownItem IconName="users-group" onClick={() => openSettings("people")}>
                        Invite Users
                    </DropdownItem>
                </ConditionalRender>

                <ConditionalRender if={checkUserAccess("super_admin_panel")}>
                    <DropdownItem IconName="dashboard" onClick={() => _history.push("/admin/panel")}>
                        Super Admin Panel
                    </DropdownItem>
                </ConditionalRender>

                <div className="header-dropdown-divider"></div>
                <DropdownItem IconName="switch-acc" onClick={handleSwitchAccount}>
                    Switch Accounts
                </DropdownItem>
                <DropdownItem IconName="log-out" onClick={props.logout} customClasses="dropdown-item-danger">
                    Logout
                </DropdownItem>
            </DropdownMenu>
        );
    };

    if (isWidthDown(windowsDimension.width, "lg")) return (
        <>
            <SmallLoginHeader />
            <SettingsPopup
                isOpen={settingsOpen}
                onClose={() => setSettingsOpen(false)}
                initialTab={settingsInitialTab}
            />
            {dataExportsOpen && canViewDataExports && <DataExports onClose={() => setDataExportsOpen(false)} />}
        </>
    );

    return (
        <div>
            <div className="header">
                <div className="header-inner">
                    <Link to={current_team.home_path || "/feed"}>
                        <img src={almaLogo} className="header-logo" />
                    </Link>

                    <div className="tab-group tab-group--line-fill header-items--full-height gap-xl">
                        {LOGIN_HEADERS.filter(h => h.access).map((header) => {
                            const tabItem = (
                                <TabItem
                                    label={header.label}
                                    iconName={header.icon}
                                    variant="line-fill"
                                    isActive={activeTab === header.key}
                                    fontClass="body-s-semibold"
                                />
                            );

                            return header.external ? (
                                <a key={header.key} href={header.url} className="no-underline h-full">
                                    {tabItem}
                                </a>
                            ) : (
                                <Link key={header.key} to={header.url} className="no-underline h-full">
                                    {tabItem}
                                </Link>
                            );
                        })}
                    </div>

                    <div className="flex items-center">
                        <Link className="header-help-link" to="/help_center" target="_blank">
                            <Button
                                Size="Small"
                                Type="Ghost"
                                ShowLeadingIcon={false}
                                ShowTrailingIcon={false}
                            >
                                Help center
                            </Button>
                        </Link>
                        <ConditionalRender if={checkUserAccess("team_switch")}>
                            {renderTeamSwitcher()}
                        </ConditionalRender>
                        <ClickableDropdown>
                            <DropdownTrigger IsIconVisible={false} customStyle={{ padding: 0 }}>
                                {current_user.image_url ? (
                                    <img src={current_user.image_url} className="header-avatar" />
                                ) : (
                                    <Avatar
                                        name={current_user.name}
                                        width={40}
                                        textStyle={{ fontSize: 20 }}
                                        isSquareOnHover={true}
                                    />
                                )}
                            </DropdownTrigger>
                            {renderLoginDropDown()}
                        </ClickableDropdown>
                    </div>
                </div>
            </div>
            <ConditionalRender if={current_team.expiring && activeTab === "NewsFeed"}>
                <div className="header-banner body-s-semibold">
                    Your free trial period will end in&nbsp;<span style={{ color: "var(--color-link-default)" }}>{current_team.trial_expiring_on_days}</span>&nbsp;days.&nbsp;<a href={"https://cal.com/almaconnect/news-scanner"} target="_blank"><u className="body-s-bold">Upgrade</u></a>&nbsp;to keep the news updates flowing.
                </div>
            </ConditionalRender>

            <SettingsPopup
                isOpen={settingsOpen}
                onClose={() => setSettingsOpen(false)}
                initialTab={settingsInitialTab}
            />
            {dataExportsOpen && canViewDataExports && <DataExports onClose={() => setDataExportsOpen(false)} />}
        </div>
    );
};

const PartialLoggedinHeader = (props) => {
    return (
        <div className="header">
            <div className="header-inner">
                <Link to="/feed">
                    <img src={almaLogo} className="header-logo" />
                </Link>
                <ClickableDropdown>
                    <DropdownTrigger IsIconVisible={false} customStyle={{ padding: 0 }}>
                        <div className="header-avatar">
                            <Icons name="user" size={24} className="icon-subtle" />
                        </div>
                    </DropdownTrigger>
                    <DropdownMenu customStyle={{ right: 0, left: "auto", width: "max-content", marginTop: 12 }}>
                        <DropdownItem IconName="log-out" onClick={props.logout} customClasses="dropdown-item-danger">
                            Logout
                        </DropdownItem>
                    </DropdownMenu>
                </ClickableDropdown>
            </div>
        </div>
    );
};

export default LoggedinHeader;
export { PartialLoggedinHeader };
